import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import qs from "qs";
import useApi from '../../../hooks/useApi';
import { Row, Col, notification } from 'antd';
import { 
  spotifyLogout,
  getNylasAuthUrl,
  getNylasAuthExchange,
  getEmailMessages,
  sendEmailMessage,
  getEmailAccounts
} from '../../../api';
import LoadingSpinner from '../../../components/loading';
import AdminContent from '../../../components/adminContent';
import FloatingContainer from '../../../components/floatingContainer'
import { isValid } from '../../../helpers/validationHelper'
import { MdArrowForwardIos } from "react-icons/md";
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import { isArray } from "lodash";
import AppContext from '../../../app/context';
import useBetaFeatures from '../../../hooks/useBetaFeatures';
import FeatureFlags from '../../../constants/featureFlags';
import BetaFeatures from '../../../constants/betaFeatures';

const API_URL = process.env.REACT_APP_API_URL;

const IntegrationsPage = () => {

  const [isLoading, setLoading] = useState(true);
  const [emailAccount, setEmailAccount] = useState({});

  useDocumentTitle("Integrations")
  const { auth, _ } = useContext(AppContext);
  const navigate = useNavigate();
  const location = useLocation();
  const [hasBetaFeature] = useBetaFeatures()

  const [sendRequest] = useApi()

  useEffect(() => {
    window.scrollTo(0, 0);
    refreshPage();
  }, []);

  const refreshPage = async () => {
    try {
      const queryStrings = qs.parse(location.search, { ignoreQueryPrefix: true })
      if (queryStrings.code) {
        const response = await sendRequest(getNylasAuthExchange(queryStrings.code))
      }
      await fetchAccounts()
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const fetchAccounts = async () => {
    try {
      const accounts = await sendRequest(getEmailAccounts())
      if (accounts.length > 0) {
        setEmailAccount(accounts[0])
      }
    } catch (error) {
      console.log(error)
    }
  }

  const connectAccount = async () => {
    try {
      const response = await sendRequest(getNylasAuthUrl())
      console.log(response)
      window.location.href = response.url
    } catch {}
  }

  const sendMessage = async () => {
    try {
      const response = await sendRequest(sendEmailMessage())
      console.log(response)
    } catch {}
  }

  const renderHeader = () => {
    return (
      <div className="p-20">
        <div>
          <span className="c-blue fw-700 cursor-default" onClick={() => navigate("/admin/setup")}>
            Setup
          </span>
          <span className="fs-10 mh-5"><MdArrowForwardIos/></span>
          <span className="cursor-default c-text-gray">
            Integrations
          </span>
        </div>
        <div className="fw-700 fs-24 mt-5">Integrations</div>
      </div>
    )
  }

  const renderEmailSection = () => {
    if (isValid(emailAccount)) {
      return (
        <Row wrap={false}>
          <Col flex={1}>
            Your clients are receiving emails from your email address!
            {/* <img src={payPalLogo} width={100}/> */}

            <div className="fw-700 mt-30">Connected account:</div>
            <div className="mt-5">{emailAccount.email}</div>
          </Col>
          <Col flex={0}>
            <div className={`status-tag green medium`}>CONNECTED</div>
          </Col>
        </Row>
      )
    } else {
      return (
        <Row wrap={false}>
          <Col flex={1}>
            Connect your email account to start sending emails from your own email address!
            <button className="small-primary-button mt-20" style={{ width: 250 }} onClick={connectAccount}>Connect Email Account</button>
          </Col>
          <Col flex={0}>
            {/* <div className={`status-tag green medium`}>CONNECTED</div> */}
            {/* <button className="small-primary-button" style={{ width: 100 }} onClick={connectAccount}>Connect</button> */}
          </Col>
        </Row>
      )
    }
  }

  const renderContent = () => {
    return (
      <>
        <FloatingContainer className="ph-20 mb-80" verticalPadding={20} maxWidth={800}>
          <div className="shadow-card p-20">
            <Row className="b-border pb-15 mb-15">
              <Col flex={1}>
                <div className="fs-20 fw-700 line-1">Email Integration</div>
              </Col>
              <Col>
                <div className="blue-link" onClick={() => {}}>Learn More</div>
              </Col>
            </Row>
            { renderEmailSection() }

            {/* <Row align="middle" wrap={false}>
              <Col flex={1}>
                Connect your email account to DJ Planning Center to send emails from your email address.

                <div className="fw-700 mt-30">Connected account:</div>
                <div className="mt-5">{stripeSettings.account_name ?? "--"} {stripeSettings.email ? `(${stripeSettings.email})` : ""}</div>
              </Col>
              <Col flex={0}>
                <div className={`status-tag green medium`}>CONNECTED</div>
              </Col>
            </Row> */}
            {/* <div>
              Connect your email account to DJ Planning Center to send emails from your email address.
            </div> */}
            {/* <div className="mt-30">
              <button className="small-primary-button" style={{width: 250}} onClick={() => connectAccount()}>Connect</button>
            </div> */}
            {/* <div className="mt-30">
              <button className="small-primary-button" style={{width: 250}} onClick={() => sendMessage()}>Send Test Email</button>
            </div> */}
          </div>
        </FloatingContainer>
      </>
    )
  }

  if (isLoading) {
    return <LoadingSpinner/>
  }

  return (
    <AdminContent header={renderHeader()} body={renderContent()}/>
  );
}

export default IntegrationsPage;